/**
 * 特有法会、相似法会
 * 
 */
export const record = {
  // 迎春祈福法会
  225: [225, 322],
  // 传授皈依法会
  230: [230, 326],
  // 恭迎佛欢喜日传灯祈福法会
  238: [238],
  // 证授五戒法会
  243: [243],
  // 法界圣凡水陆普度大斋胜会
  245: [245],
  // 恭迎释迦牟尼佛成道日祝圣法会
  249: [249, 333],
  // 元旦祈福法会
  309: [309, 336],
  // 恭迎观音菩萨圣诞日祝圣法会
  311: [311],
  // 恭迎观音菩萨成道日祝圣法会
  312: [312],
  // 恭迎观音菩萨出家日祝圣法会
  313: [313],
  // 恭迎阿弥陀佛圣诞日暨永明延寿大师诞辰1120周年纪念日法会
  315: [315],
  // 药师琉璃灯
  297: [297]
}